import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'

import { itinerariesSchema } from 'features/Services/components/NewServicesV2/components/ItinerariesCard/schema'
import { vehiclesSchema } from 'features/Services/components/NewServicesV2/components/VehiclesCard/schema'
import { IServicesForm } from 'features/Services/components/NewServicesV2/components/ServicesForm/types'

const messages = defineMessages({
  requiredCode: {
    id: 'service.form.code.required',
    defaultMessage: 'The code is required'
  },
  maxCode: {
    id: 'service.form.code.max',
    defaultMessage: 'The code can be up to 10 characters'
  },
  required: {
    id: 'service.form.required',
    defaultMessage: 'Field Required'
  }
})

export const servicesFormSchema = (intl: IntlShape): yup.SchemaOf<IServicesForm> => {
  return yup.object().shape({
    reason: yup.string().required(intl.formatMessage(messages.required)) as yup.SchemaOf<IServicesForm['reason']>,
    services: yup.array().of(
      yup
        .object()
        .shape({
          code: yup
            .string()
            .max(10, intl.formatMessage(messages.maxCode))
            .required(intl.formatMessage(messages.requiredCode)),
          ...itinerariesSchema(intl, { isEndDateOptional: true }).fields,
          ...vehiclesSchema(intl).fields
        })
        .required()
    )
  })
}
